export default "__VITE_ASSET__B$8emBfe__"